// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app_3Ec5M"};